<template>
	<aside id="sidebar" :class="[{active: isTabActive}, $css(styles.sidebar), $css(styles.sidebarActive)]">
		<SourcesWidget/>
		<ThemeSelector/>
		<PaletteColors/>
		<FontSelector/>
		<AdvancedParams/>
	</aside>
</template>

<script>
	import {mapState} from "vuex";
	import consts from "@/common/consts";
	import {getInMediaQuery as gimq, MQ_SIZES} from "@/utils/cssUtils";
	import SourcesWidget from "./customization/SourcesWidget";
	import ThemeSelector from "./customization/ThemeSelector";
	import PaletteColors from "./customization/PaletteColors";
	import FontSelector from "./customization/FontSelector";
	import AdvancedParams from "./customization/AdvancedParams";

	function styles() {
		return this.$style({
			sidebar: gimq(
				[MQ_SIZES.W, {width: "32.7%"}],
				[MQ_SIZES.L, {padding: "27px 15px", height: "100%"}],
				[MQ_SIZES.D, {width: "100%", display: "none", padding: "20px 25px 34px 21px"}]),
			sidebarActive: this.isTabActive ? gimq(MQ_SIZES.D, {display: "block"}): {}
		});
	}

	export default {
		name: "CustomizeTab",
		components: {
			AdvancedParams,
			FontSelector,
			PaletteColors,
			SourcesWidget,
			ThemeSelector,
		},
		computed: {
			...mapState({
				isTabActive: (state) => (state.app.activeTab === consts.TABS.CUSTOMIZATION),
			}),
			styles,
		},
	}

</script>

<style lang="scss" scoped>
	@import "../../assets/scss/_variables.scss";

	#sidebar {
		width: 26.6%;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
		border: 1px solid $bali;
		background: $white;
		padding: 27px 23px 105px 20px;
		display: block;
		overflow-y: auto;

		&.active {
			display: block;
		}

		.btn-box {
			text-align: center;
		}
	}
</style>
